import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr
} from '@chakra-ui/react';
import React from 'react';
import { MessageSignagesDataType } from '../../../pages/NoticeMessageList';

interface props {
  MessageDataList: MessageSignagesDataType | null | undefined;
}
export const TramMessageTable: React.FC<props> = (props) => {
  const { MessageDataList } = props;
  return (
    <>
      <TableContainer h='100%' w='100%' overflowY='auto' overflowX='unset'>
        <Table variant='simple'>
          <Thead borderWidth='1px' position='sticky' top={0} zIndex='docked'>
            <Tr bg='gray.800'>
              <Th
                textAlign='center'
                borderWidth='1px'
                color='white'
                fontSize='16px'
              >
                駅名
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {MessageDataList?.signageDatas.map((data, i) => {
              return (
                <Tr key={'TramMessageRow_' + i}>
                  <Td textAlign='center'>{data.signage_name}</Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableContainer>
    </>
  );
};
